var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 3C3.76522 3 4.01957 3.10536 4.20711 3.29289C4.39464 3.48043 4.5 3.73478 4.5 4V16C4.5 16.2652 4.39464 16.5196 4.20711 16.7071C4.01957 16.8946 3.76522 17 3.5 17C3.23478 17 2.98043 16.8946 2.79289 16.7071C2.60536 16.5196 2.5 16.2652 2.5 16V4C2.5 3.73478 2.60536 3.48043 2.79289 3.29289C2.98043 3.10536 3.23478 3 3.5 3ZM11.207 6.293C11.3945 6.48053 11.4998 6.73484 11.4998 7C11.4998 7.26516 11.3945 7.51947 11.207 7.707L9.914 9H17.5C17.7652 9 18.0196 9.10536 18.2071 9.29289C18.3946 9.48043 18.5 9.73478 18.5 10C18.5 10.2652 18.3946 10.5196 18.2071 10.7071C18.0196 10.8946 17.7652 11 17.5 11H9.914L11.207 12.293C11.3892 12.4816 11.49 12.7342 11.4877 12.9964C11.4854 13.2586 11.3802 13.5094 11.1948 13.6948C11.0094 13.8802 10.7586 13.9854 10.4964 13.9877C10.2342 13.99 9.9816 13.8892 9.793 13.707L6.793 10.707C6.60553 10.5195 6.50021 10.2652 6.50021 10C6.50021 9.73484 6.60553 9.48053 6.793 9.293L9.793 6.293C9.98053 6.10553 10.2348 6.00021 10.5 6.00021C10.7652 6.00021 11.0195 6.10553 11.207 6.293Z",
    fill: "#FF4C4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.13bb405d17a06f761ad04bea94984491.svg";
export { ForwardRef as ReactComponent };